import useSWR from "swr";
import { fetchFeeStats } from "lib/indexer/client";
import { getCurrentEpochStartedTimestamp } from "domain/stats";
import { CONFIG_UPDATE_INTERVAL } from "lib/timeConstants";

export function useV1FeesInfo(_chainId: number) {
  const { data: feesInfo } = useSWR(
    ["useV1FeesInfo", _chainId],
    async () => {
      try {
        const epochStartedTimestamp = getCurrentEpochStartedTimestamp();
        const res = await fetchFeeStats(epochStartedTimestamp);
        return {
          weeklyFees: BigInt(res.weeklyFees),
          totalFees: BigInt(res.totalFees),
        };
      } catch {
        return { weeklyFees: 0n, totalFees: 0n };
      }
    },
    { refreshInterval: CONFIG_UPDATE_INTERVAL }
  );

  return feesInfo;
}
